import React from "react";
import { observer } from "mobx-react";
import { setCurrentView } from "core/utils";
import { ConfirmingReportFileUploadViewStore } from "application/confirming-report/stores";
import { ConfirmingReportFileUploadTemplate } from "themes/application/confirming-report/pages";

@setCurrentView((rootStore) => new ConfirmingReportFileUploadViewStore(rootStore), "confirmingReportFileUploadViewStore")
@observer
class ConfirmingReportFileUpload extends React.Component {
    render() {
        return <ConfirmingReportFileUploadTemplate { ...this.props }/>
    }
}

export default ConfirmingReportFileUpload;
